import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

// You can use your theme here if needed
const SubContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: "#111827",
  border: "1px solid #374151",
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 3, // Usually 12px if default is 4
}));

export default SubContainer;
